<script setup lang="ts">
import type { PopoverProps } from '#ui/types';

// PROPS
interface Props {
    text?: string;
    content?: PopoverProps['content'];
}

defineProps<Props>();

// COMPOSABLES
const isHoverable = useMediaQuery('(hover: hover) and (pointer: fine)');

// DATA
const popoverMode = ref<PopoverProps['mode']>('hover');

// LIFECYCLE
onMounted(() => {
    watch(isHoverable, value => (popoverMode.value = value ? 'hover' : 'click'), { immediate: true });
});
</script>

<template>
    <UPopover :mode="popoverMode" :ui="{ arrow: 'fill-primary-950' }" :content="content" :open-delay="300" arrow>
        <slot />

        <template #content>
            <div class="max-w-[90vw] px-2.5 py-1 text-xs select-none">
                <slot name="content">{{ text }}</slot>
            </div>
        </template>
    </UPopover>
</template>
